<template>
  <div class="print__table_row" v-if="item.total > 0">
    <!--    -->
    <template v-if="!item.options">
      <!--      v-if="item.options"-->
      <div class="print__table_counter"></div>
      <div>
        <div>
          <b>{{ title }} {{ currentIndex }}:</b> {{ name }}, {{ color }}
        </div>
      </div>
      <div>
        <div v-if="square > 0">{{ square }} м<sup>2</sup></div>
        <div v-if="count > 0">{{ count }} шт.</div>
      </div>
      <div>{{ pricePrepayFormat }} руб</div>
      <div>{{ priceLastPay }} руб</div>
      <div>{{ priceWithDiscountFormat }} руб</div>
    </template>

    <template v-else>
      <PrintGoodsSibling
        v-for="(layer, index) in item.options"
        v-model="siblingData[index]"
        :key="layer.id"
        :item="layer"
        :index="index"
        :category="category"
        :parentId="item.id"
        :letter="letter"
        :prepay="item.prepay"
      />
    </template>
  </div>
</template>

<script>
import wNumb from "wnumb";
import PrintGoodsSibling from "@/components/Print-goods-sibling";

export default {
  name: "Print-goods",
  // eslint-disable-next-line vue/no-unused-components
  components: { PrintGoodsSibling },
  data() {
    return {
      siblingData: []
    };
  },
  props: {
    title: String,
    item: Object,
    index: Number,
    category: String,
    letter: String
  },
  computed: {
    currentIndex() {
      return this.index > 0 ? this.index + 1 : "";
    },
    square() {
      return this.item.square;
    },
    count() {
      return this.item.count;
    },
    name() {
      return this.item.name;
    },
    color() {
      return this.item.color;
    },
    priceCount() {
      return this.item.total * this.extra;
    },
    price() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(this.priceCount || 0);
    },
    priceWithDiscount() {
      return this.priceCount * this.discount ?? 0;
    },
    priceWithDiscountFormat() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(this.priceWithDiscount);
    },
    pricePrepay() {
      let total = (this.priceWithDiscount / 100) * this.item.prepay;
      return wNumb({
        decimals: 0,
        thousand: ""
      }).to(total ?? 0);
    },
    pricePrepayFormat() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(Number(this.pricePrepay));
    },
    priceLastPay() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(Number(this.priceWithDiscount) - Number(this.pricePrepay));
    },
    discount() {
      return 1 - this.$store.getters.currentCalculation.discount / 100;
    },
    extra() {
      return 1 + this.$store.getters.currentOrder.extra / 100;
    }
  }
};
</script>
